
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  UserCircle, NotebookPen, Home, Plus, Menu
} from 'lucide-react';

function BottomNav({ onRecordButtonClick }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const navTabs = [
    { key: 'home', label: 'ホーム', icon: <Home size={24} />, path: '/all-records', className: 'tutorial-home' },
    { key: 'study', label: '学習ハブ', icon: <NotebookPen size={24} />, path: '/study', className: 'tutorial-study' },
    { key: 'mypage', label: 'マイページ', icon: <UserCircle size={24} />, path: '/records', className: 'tutorial-mypage' },
    { key: 'settings', label: 'メニュー', icon: <Menu size={24} />, path: '/settings', className: '' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/90 dark:bg-gray-900/90 backdrop-blur-lg border-t border-slate-200 dark:border-slate-800 pb-safe">
        <div className="flex justify-around items-center h-16 max-w-2xl mx-auto px-2 relative">
          
          {navTabs.slice(0, 2).map((tab) => {
            const isActive = pathname === tab.path;
            return (
              <button
                key={tab.key}
                onClick={() => navigate(tab.path)}
                className={`flex flex-col items-center justify-center w-14 sm:w-16 py-1 transition-colors ${tab.className} ${
                  isActive ? 'text-indigo-600 dark:text-indigo-400' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
                }`}
              >
                {tab.icon}
                <span className="text-[10px] font-medium mt-1">{tab.label}</span>
              </button>
            );
          })}

          {/* Center Action Button */}
          <div className="relative -top-5">
            <button
              onClick={onRecordButtonClick}
              className="flex flex-col items-center justify-center w-14 h-14 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg shadow-indigo-300 dark:shadow-indigo-900/50 transition-transform hover:scale-105 active:scale-95 tutorial-record"
            >
              <Plus size={28} strokeWidth={2.5} />
            </button>
          </div>

          {navTabs.slice(2).map((tab) => {
            const isActive = pathname === tab.path;
            return (
              <button
                key={tab.key}
                onClick={() => navigate(tab.path)}
                className={`flex flex-col items-center justify-center w-14 sm:w-16 py-1 transition-colors ${tab.className} ${
                  isActive ? 'text-indigo-600 dark:text-indigo-400' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'
                }`}
              >
                {tab.icon}
                <span className="text-[10px] font-medium mt-1">{tab.label}</span>
              </button>
            );
          })}

        </div>
      </nav>
  );
}

export default BottomNav;
